import React from 'react';
import ReactDOM from 'react-dom';
// import './index.css';
import LandingApp from './LandingApp';
import reportWebVitals from './reportWebVitals';

// import Layout from './layout/Layout'

// Use require instead of import, and order matters
require('@solana/wallet-adapter-react-ui/styles.css');

ReactDOM.render(
  <React.StrictMode>
    {/* <Wallet /> */}
    <LandingApp />
  </React.StrictMode>,
  document.getElementById('root')
);

reportWebVitals();
